/**
 * 贴纸模板选择
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 *
 * source           行内显示项，显示前三个   数据项
 * currentItem      当前选择项
 * onSelectBack     选择项回调
 * sku              当前sku数据
 */
import React from 'react';
import {Row, Col, Popover, message, Empty, Input,Spin} from 'antd';
import {isEmpty,trim} from '@utils/utils';
import Lang from "@components/Lang/Lang";
import EssaModal from "@components/EssaModal/EssaModal";
import PropTypes from "prop-types";
import "./Index.less";
import CustomsDeclarationStickerAction from "../CustomsDeclarationSticker.action";

const {Search} = Input

class StickerTemplateSelector extends React.Component{
    static propTypes ={
        source:PropTypes.array.isRequired,
        onSelectBack: PropTypes.func.isRequired,
        sku: PropTypes.object.isRequired,
        currentItem:PropTypes.object,
        newStickerList:PropTypes.array,
    }
    static defaultProps = {
        source: [],
        currentItem:{}
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showModal:false,
            list:[],
            keyWord:'',
            moreList:[]
        }
    }
    //渲染模板列表
    renderList(list=[],currentItem={}){
        let children = [];
        for(let i=0,iLen=list.length;i<iLen&&i<3;i++){
            const item = list[i];
            children.push(<div key={i} className={item.stickerCode==currentItem.stickerCode?'stItem on':'stItem'} onClick={()=>this.onChangeItem(item,currentItem)}>
                <span>{item.stickerName}({item.stickerCode})</span>
                {item&&item.stickerPicFileUrl&&<Popover placement="left" arrow={true} trigger="click" content={
                   <img src={item.stickerPicFileUrl+'@!600'} alt=""/>
                }>
{/* <<<<<<< HEAD
                    <i className="icon iconfont icon-search-look"></i>
======= */}
                    <i className="ri-zoom-in-line"></i>
{/* >>>>>>> remotes/origin/master */}
                </Popover>}
            </div>)
        }
        return children;
    }
    onChangeNavItem(item={},currentItem={}){
        if(item.stickerCode!=currentItem.stickerCode){
            this.setState({
                navItem:item
            })
        }
    }
    onChangeItem(item={},currentItem={}){
       // if(item.id!=currentItem.id)
        if(item.stickerCode!=currentItem.stickerCode){
            this.setState({
                currentItem:item,
                navItem:item
            })
            if(this.props.onSelectBack)this.props.onSelectBack(item)
            if(this.props.onChange)this.props.onChange(item)
        }
    }
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 获取更多贴纸模板列表
     * */
    getStickerTemplateList(data){
        this.loading(true);
        CustomsDeclarationStickerAction.getStickerTemplateList(data).then(res=>{
            // console.log('获取贴纸模板列表',res)
            this.loading(false);
            const {success,valid,models,} = res.data||{};
            const list = models || [];
            const {currentItem} = this.props;
            let navItem = {};
            if(currentItem&&currentItem.stickerCode){
                navItem = list.find(item=>item.stickerCode==currentItem.stickerCode)||{};
            }else navItem = list[0];
            if(success&&valid){
                this.setState({
                    moreList:models||[],
                    // showModal:true,
                    navItem:navItem
                })
            }else this.setState({
                moreList:models||[],
                // showModal:true,
            })
        }).catch(err=>function () {
            this.loading(false)
            message.info(Lang({
                id:'WangLuoGuZhangHuoZheXiTon',
                default:'网络故障或者系统问题，服务暂不可用'
            }))
        })
    }
    /**
     * 打开窗口
     * */
    openModal = (sku={}) => {
        if(sku.poId){
            this.setState({
                showModal:true,
            })
            this.getStickerTemplateList({
                poId:sku.poId,
                keyword :this.state.keyWord || ''
            });

        }
    }
    /**
     * 渲染 左则
     * **/
    renderNav(list=[],currentItem={}){
        let children = [];
        list.forEach((item,inx)=>{
            children.push(<div className={item.stickerCode==currentItem.stickerCode?'navLi on':'navLi'} key={inx} onClick={()=>this.onChangeNavItem(item,currentItem)}>
                {/* <span className="iconfont icon-sanjiaogou iconRight"></span> */}
                <span>{item.stickerName}({item.stickerCode})</span>
            </div>)
        })
        return children;
    }
    handleOk(){
        const {navItem} = this.state;
        if(navItem&&navItem.stickerCode){
            this.props.onSelectBack(navItem);
            if(this.props.onChange)this.props.onChange(navItem)
        }
        this.setState({
            // list: [navItem],
            showModal:false,
            keyWord:''
        })
    }
    handleClose(){
        this.setState({
            showModal:false,
            keyWord:''
        })
    }

    onSearch = () => {

        this.getStickerTemplateList({
            poId:this.props.sku.poId,
            keyword :this.state.keyWord || ''
        });


    }
    componentDidMount() {
        const { source,currentItem } = this.props;
        this.setState({
            list: source||[],
            navItem:currentItem
        })

    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }

    render(){
        const {sku,currentItem, newStickerList } =this.props;
        const {loading, showModal, list,moreList,navItem} =this.state;

        return (<div className={'stickerTemplateSelector'} key={"stickerTemplateSelector_"+sku.id}>
                {this.renderList(newStickerList||list,currentItem)}
                <span className={'more'} onClick={()=>this.openModal(sku)}>{Lang({id: 'GengDuo', default: '更多'})}</span>
                {showModal&&<EssaModal title={Lang({id:'XuanZeTieZhiMoBan',default:'选择贴纸模板'})}
                                       open={showModal}
                                       key={"pop_stickerTemplateSelector_"+sku.id}
                                   width={1050}
                                   onOk={this.handleOk.bind(this)}
                                   onCancel={()=>this.handleClose()}>
                    <Row>
                        <Col span={8}>
                                <Search placeholder={Lang({id:'QingShuRu',default:'请输入'})} value={this.state.keyWord} onSearch={this.onSearch} style={{width:'100%',marginBottom:'40px'}} onChange={(e) => {
                                this.setState({
                                    keyWord:e.target.value
                                })
                            }} />
                        </Col>
                        </Row>
                    <Spin tip='loading' spinning={loading}>
                        <div className={'modalStickerTemplateStyle'}>
                            {moreList&&moreList.length>0?
                        <Row gutter={24}>
                            <Col span={8} className={'line'}>
                                <div className={'leftNav'}>
                                {this.renderNav(moreList,navItem)}
                                </div>
                            </Col>
                            <Col span={16}>
                                <div className={'templateFileShow'}>
                                    {navItem&&navItem.stickerPicFileUrl&&<img src={navItem.stickerPicFileUrl+'@!600'} />}
                                </div>
                            </Col>
                        </Row>: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={Lang({id:'ZanWuShuJu',default:'暂无数据'})} />}
                        </div>
                    </Spin>
                </EssaModal>}
        </div>)
    }
}

export default StickerTemplateSelector;
